/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectStatus } from '../../models/project-status';
import { ProjectStatusCounterDto } from '../../models/project-status-counter-dto';

export interface GetProjectsStats$Params {
  isArchived?: boolean | null;
  isPublic?: boolean | null;
  createdById?: string | null;
  projectStatuses?: Array<ProjectStatus>;
}

export function getProjectsStats(http: HttpClient, rootUrl: string, params?: GetProjectsStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectStatusCounterDto>> {
  const rb = new RequestBuilder(rootUrl, getProjectsStats.PATH, 'get');
  if (params) {
    rb.query('isArchived', params.isArchived, {});
    rb.query('isPublic', params.isPublic, {});
    rb.query('createdById', params.createdById, {});
    rb.query('projectStatuses', params.projectStatuses, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectStatusCounterDto>;
    })
  );
}

getProjectsStats.PATH = '/v0/projects/stats';
